import { gql } from 'apollo-angular';

export const GET_DAILY_EXPENSE = gql`
  query dailyExpenses($search: String) {
    dailyExpenses(search: $search) {
      id
      date
      supplierId
      dailyExpenseNo
      paymentMethod
      fileUploadUrl
      supplierData {
        id
        supplierName
        supplierCode
        address
        contact
        branchId
      }
      subTotal
      tax
      adjustment
      total
      status
      createdAt
      updatedAt
      deletedAt
    }
  }
`;

export const GET_DAILY_EXPENSE_BY_ID = gql`
  query dailyExpense($id: Int!) {
    dailyExpense(id: $id) {
      id
      date
      supplierId
      supplierData {
        id
        supplierName
        supplierCode
        address
        contact
        status
      }
      subTotal
      dailyExpenseNo
      paymentMethod
      tax
      chequeNo
      chequeDate
      adjustment
      total
      fileUploadUrl
      dailyExpenseItemsOfExpense {
        id
        date
        stationoryId
        stationoryData {
          stationoryName
        }
        quantity
        unitPrice
        tax
        discount
        total
      }
    }
  }
`;

export const GET_SUPPLIERS_LIST = gql`
  query suppliers($search: String) {
    suppliers(search: $search) {
      id
      supplierName
      supplierCode
      address
      contact
      status
      createdAt
      updatedAt
      deletedAt
    }
  }
`;

export const GET_STATIONARY_LIST = gql`
  query stationories($search: String) {
    stationories(search: $search) {
      id
      stationoryName
      stationoryCode
      price
      stock
      status
      createdAt
      updatedAt
      deletedAt
    }
  }
`;
